import { useMemo } from 'react';

/**
 * Transforme les enregistrements Airtable "Calcul TMP" en map indexée par année-trimestre.
 *
 * @param {Array} calculTMP - Enregistrements Airtable de la table "Calcul TMP"
 * @returns {Object} calculMap - { "2025-Q1": { raw, tmp, caTotal, joursTotaux } }
 */
export function useCalculMap(calculTMP) {
  return useMemo(() => {
    const map = {};
    (calculTMP || []).forEach(rec => {
      const annee = rec.fields?.Année;
      const trimestreField = rec.fields?.Trimestre;
      let trimestre = null;
      if (typeof trimestreField === 'string' && trimestreField.toUpperCase().startsWith('Q')) {
        trimestre = parseInt(trimestreField.replace(/[^0-9]/g, ''), 10);
      } else if (typeof trimestreField === 'number') {
        trimestre = trimestreField;
      }
      if (annee && trimestre) {
        const tmpValue = rec.fields?.Calculation ?? rec.fields?.TMP ?? rec.fields?.['Taux moyen'] ?? null;
        map[`${annee}-Q${trimestre}`] = {
          raw: rec,
          tmp: tmpValue,
          caTotal: rec.fields?.['CA total GIE d...'] ?? rec.fields?.['CA total GIE'] ?? rec.fields?.['CA total GIE d'] ?? null,
          joursTotaux: rec.fields?.['Jours totaux GIE'] ?? null
        };
      }
    });
    return map;
  }, [calculTMP]);
}
